module.exports = __webpack_public_path__ + "assets/ev-charging.f2573188.svg";